import { Dispatch } from 'react';
import { connect } from 'react-redux';
import { AddressesActions } from '../../../../details/addresses/addressesActions';
import { AddressesAction } from '../../../../details/addresses/addressesActionType';
import { IMasterAddress } from '../../../../api/addressSearch/addressSearch';
import { IReduxRootState } from '../../../reduxRootState.interface';
import { ErrorResolutionActions } from '../../errorResolution/errorResolutionActions';
import { ErrorResolution } from '../../errorResolution/errorResolution';
import JPPostalCodeField from './JPPostalCodeField';

function mapStateToProps(state: IReduxRootState) {
    return {
        locale: state.app.locale,
    };
}

function mapDispatchToProps(dispatch: Dispatch<AddressesAction>) {
    return {
        setMasterAddress: (masterAddress: IMasterAddress | null) => {
            dispatch(AddressesActions.setMasterAddress(masterAddress));
        },
        showAddressSearchError: (error: ErrorResolution) => {
            dispatch(ErrorResolutionActions.processErrorResolution(error));
        },
        changeStateInputDisabled: (status: boolean) => {
            dispatch(AddressesActions.changeStateInputDisabled(status));
        },
    };
}

const JPPostalCodeFieldContainer = connect(mapStateToProps, mapDispatchToProps)(JPPostalCodeField);

export default JPPostalCodeFieldContainer;
